import { post, downloadStreamFile } from './http'

const baseUrl = '/api/meas/admin/trade/order'

// 获取订单列表
export const getOrderList = data => post(`${baseUrl}/getOrderList`, data)

// 获取学员下拉
export const getStudentListBySelect = data => post('/api/meas/admin/teach/class/getStudentListBySelect', data)

// 获取 班级下拉 
export const getClassListBySelect = data => post('/api/meas/admin/teach/class/getClassListBySelect', data)

// 新增订单
export const saveOrderInfo = data => post(`${baseUrl}/saveOrderInfo`, data)

// 订单详情 
export const getOrderDetail = data => post(`${baseUrl}/getOrderDetail`, data)

// 订单关闭 
export const closeOrder = data => post(`${baseUrl}/closeOrder`, data)

// 确认支付
export const confirmOrderPayResult = data => post(`${baseUrl}/confirmOrderPayResult`, data)

// 订单退款
export const reFundOrder = data => post(`${baseUrl}/reFundOrder`, data)

// 导出
export const exportOrder = (data, filename) => downloadStreamFile(`${baseUrl}/exportOrder`, data, filename)

// 获取交易概况 
export const getFinanceSummary = data => post('/api/meas/admin/trade/finance/getFinanceSummary', data)

// 交易构成校区 
export const getCampusFinanceInfo = data => post('/api/meas/admin/trade/finance/getCampusFinanceInfo', data)

// 获取交易构成班级     
export const getClassFinanceInfo = data => post('/api/meas/admin/trade/finance/getClassFinanceInfo', data)